<div aria-hidden="true" aria-labelledby="confirmBidModal" class="modal fade lineheight"
     id="{{'confirmBidModal' + offer.id}}"
     role="dialog"
     tabindex="-1">
  <div class="modal-dialog" role="document">
    <div class="modal-content">

      <div class="modal-header">
        <h5 class="modal-title">
          {{ (isAuctionOffer ? 'offer-maintenance.detail.bids.bidForDealer' : 'offer-maintenance.detail.buynow.purchaseForDealer') | translate }}
        </h5>
        <button (click)="cancel()" aria-label="Close" class="btn-close btn-close-white" data-bs-dismiss="modal"
                type="button">
          <span aria-hidden="true"></span>
        </button>
      </div>

      <div class="modal-body">
        <form>
          @if (allowedToSeeManualInput && !isBuyNowOffer) {
            <div class="row col justify-content-end d-inline-block pe-0 text-end">
              @if (!manualInput) {
                <button type="button" class="btn-popover mb-1" (click)="switchDealerEntryType()">
                  <ucs-icon [shape]="'edit-2'"></ucs-icon>
                  <strong>{{ 'initial-proposal.dialog.manual-input' | translate }}</strong>
                </button>
              }
              @if (manualInput) {
                <button type="button" class="btn-popover mb-1" (click)="switchDealerEntryType()">
                  <ucs-icon [shape]="'search'" [class]="'blue'"></ucs-icon>
                  <strong>{{ 'initial-proposal.dialog.search-dealer' | translate }}</strong>
                </button>
              }
            </div>
          }
          @if (!manualInput) {
            <ucs-dealer-autocomplete class="d-inline-block col-12 ps-0"
                                     [sourceFunction]="dealerAutoCompleteSourceFunction"
                                     [channel]="offer.channel.data"
                                     [class]="'form-control ps-3'"
                                     [label]="'offer-maintenance.detail.bids.bidder' | translate"
                                     [placeholder]="'offer-maintenance.detail.bids.bidder.select' | translate"
                                     [sidebar]="true"
                                     [offerId]="offer.id"
                                     (onSelected)="dealerSelected($event)"></ucs-dealer-autocomplete>
            @if (dealer?.name) {
              <div class="col-12 mt-2 ms-2 ps-0">
                {{ dealer?.companyNumber }} {{ dealer?.name }}<br/>
                {{ dealer?.address }}<br/>
                {{ dealer?.zipCode }} {{ dealer?.city }}<br/>
                {{ dealer?.firstName }} {{ dealer?.lastName }}
              </div>
            }
          }
          @if (manualInput && !isBuyNowOffer) {
            <ucs-manual-dealer-input [vehicleId]="vehicleItem.vehicleId"
                                     (externalDealerChanged)="dealerEntered($event)"
                                     (validityChanged)="manualInputValid = $event"></ucs-manual-dealer-input>
          }
          <ucs-net-gross-input (backGrossPriceChange)="currentPrice.gross = $event"
                               (backNetPriceChange)="currentPrice.net = $event"
                               (inputErrorOutput)="inputError=$event"
                               [currency]="offer.offerType.data === 'BUYNOW' ? (offer| cast:BuyNowOfferDto).price.currency.data : (offer| cast:AuctionOfferDto).startPrice.currency.data"
                               [grossPriceValidationError]="grossPriceValidationError"
                               [grossPrice]="currentPrice?.gross"
                               [headingTranslationKey]="isBuyNowOffer ? 'buy-now.dialog.your-price' : 'bid.dialog.your-bid'"
                               [hideGrossPrice]="!offer.nationalSale"
                               [netPriceValidationError]="validationError"
                               [netPrice]="currentPrice?.net"
                               [priceInputDisabled]="isBuyNowOffer"
                               [sectionScope]="'SALES_MAINTENANCE'"
                               [vehicleOrOfferDto]="offer"></ucs-net-gross-input>

          <div class="col-12 mt-2 ps-0">
            <strong>{{ 'vehicle-maintenance.detail.initial-proposal.comment' | translate }}</strong>
            <textarea [(ngModel)]="comment" class="col-8 mt-1 mb-3 form-control" maxlength="250" name="comment">
            </textarea>
          </div>
          @if (generalValidationError) {
            <div class="row col-12 mt-1">
              <span class="error">{{ generalValidationError | translate }}</span>
            </div>
          }
          @if (vehicleItem.thermalWindowAffected) {
            <div class="row col-12 mt-1">
              <span>
                <ucs-icon [shape]="'alert-triangle'" [class]="'red'" [size]="17"></ucs-icon>
                {{ 'thermal-window.info' | translate }}
              </span>
            </div>
          }
        </form>
      </div>
      <div class="modal-footer">
        @if (isAuctionOffer) {
          <ucs-countdown class="me-auto" [expirationDate]="offer?.expiration"
                         [isExternalDealerBidDialog]="true"></ucs-countdown>
        }
        <button (click)="cancel()" class="btn btn-secondary button-cancel" data-bs-dismiss="modal" type="button">{{
                'bid.dialog.cancel' | translate
          }}
        </button>


        <button (click)="isAuctionOffer ? bid() : purchase()" [disabled]="inputError || isBuyNowOffer && (dealer === undefined || comment === undefined || comment?.trim().length < 1)"
                class="btn btn-primary button-save"
                type="button">
          {{ (isAuctionOffer ? 'bid.dialog.bid' : 'offer-item.buy-now') | translate }}
        </button>

      </div>
    </div>
  </div>
</div>
